
class LoadingScreen {

  domElementScreen: HTMLElement;
  domElementProgress: HTMLElement;

  constructor() {
    this.domElementScreen = document.getElementById('loadingScreen');
    this.domElementProgress = document.getElementById('loadingScreenProgress');
  }

  update(percentage: number) {
    this.domElementProgress.textContent = `${percentage} %`;
  }

  hide() {
    this.domElementScreen.style.display = 'none';
  }

}

export default new LoadingScreen();
